/* ============================================================================
   ReFound — theme behaviour (vanilla JS, no dependencies)
   Light/dark toggle, mobile nav drawer, slide-in Ajax cart, cursor spotlight,
   accordions, variant picker, quantity steppers, wishlist + recently-viewed.
   ============================================================================ */
(function () {
  "use strict";

  /* ── Theme toggle (sets BOTH data-theme + .dark like the original) ─────── */
  var root = document.documentElement;
  function applyTheme(mode) {
    if (mode === "dark") { root.setAttribute("data-theme", "dark"); root.classList.add("dark"); }
    else { root.setAttribute("data-theme", "light"); root.classList.remove("dark"); }
    try { localStorage.setItem("refound-theme", mode); } catch (e) {}
  }
  try { var stored = localStorage.getItem("refound-theme"); if (stored) applyTheme(stored); } catch (e) {}
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-theme-toggle]");
    if (!toggle) return;
    var current = root.getAttribute("data-theme") === "dark" ? "dark" : "light";
    applyTheme(current === "dark" ? "light" : "dark");
  });

  /* ── Drawer open/close (mobile nav + cart + wishlist) ──────────────────── */
  var _drawerLastFocus = null, _drawerTrapEl = null;
  function _drawerFocusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (n) { return n.offsetParent !== null; });
  }
  function _drawerTrap(e) {
    if (e.key !== "Tab" || !_drawerTrapEl) return;
    var f = _drawerFocusables(_drawerTrapEl); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openDrawer(id) {
    var drawer = document.getElementById(id), overlay = document.getElementById("drawer-overlay");
    if (!drawer) return;
    _drawerLastFocus = document.activeElement;
    drawer.classList.add("is-open");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    drawer.setAttribute("aria-hidden", "false");
    _drawerTrapEl = drawer;
    document.addEventListener("keydown", _drawerTrap);
    setTimeout(function () { var c = drawer.querySelector("[data-drawer-close]") || _drawerFocusables(drawer)[0]; if (c) { try { c.focus(); } catch (e) {} } }, 60);
  }
  function closeDrawers() {
    document.querySelectorAll(".drawer.is-open").forEach(function (d) { d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true"); });
    var overlay = document.getElementById("drawer-overlay");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", _drawerTrap);
    _drawerTrapEl = null;
    if (_drawerLastFocus && _drawerLastFocus.focus) { try { _drawerLastFocus.focus(); } catch (e) {} }
    _drawerLastFocus = null;
  }
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute("data-drawer-open")); return; }
    if (e.target.closest("[data-drawer-close]") || e.target.id === "drawer-overlay") closeDrawers();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawers(); });

  /* ── Ajax cart ─────────────────────────────────────────────────────────── */
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-GB", {
        style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP"
      }).format(cents / 100);
    } catch (e) { return "£" + (cents / 100).toFixed(2); }
  }
  function refreshCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = count; el.style.display = count > 0 ? "" : "none"; });
  }
  function shipBar(cart) {
    var thr = (window.ReFoundFreeShip || 0) * 100;
    if (!thr || thr <= 0) return "";
    var rem = thr - cart.total_price;
    if (rem <= 0) return '<div class="ship-bar ship-bar--done"><p class="ship-bar__msg">You have unlocked <b>free delivery</b>.</p><div class="ship-bar__track"><div class="ship-bar__fill" style="width:100%"></div></div></div>';
    var pct = Math.max(4, Math.min(100, Math.round((cart.total_price / thr) * 100)));
    return '<div class="ship-bar"><p class="ship-bar__msg">Spend <b>' + money(rem) + '</b> more for free delivery</p><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  }
  function loadXsell(cart) {
    var box = document.querySelector("[data-xsell]");
    if (!box || !cart.items || !cart.items.length) return;
    fetch("/recommendations/products.json?product_id=" + cart.items[0].product_id + "&limit=4&intent=related", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var have = cart.items.map(function (i) { return i.product_id; });
        var items = ((d && d.products) || []).filter(function (p) { return have.indexOf(p.id) === -1; }).slice(0, 3);
        if (!items.length) return;
        box.innerHTML = "<h4>You may also like</h4>" + items.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || "";
          return '<div class="cart-xsell__item"><img src="' + img + '" alt="" loading="lazy"><a class="t" href="' + p.url + '">' + p.title + '</a><a class="cart-xsell__add" href="' + p.url + '">View</a></div>';
        }).join("");
        box.hidden = false;
      })
      .catch(function () {});
  }
  function renderCart(cart) {
    refreshCartCount(cart.item_count);
    var rfPct = (window.ReFoundMember && Number(window.ReFoundMemberPct) > 0 && Number(window.ReFoundMemberPct) < 100) ? Number(window.ReFoundMemberPct) : 0;
    function rfMember(c) { return rfPct ? Math.round(c * (100 - rfPct) / 100) : c; }
    var body = document.getElementById("cart-drawer-body"), foot = document.getElementById("cart-drawer-foot");
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="mini-cart__empty"><p>Your basket is empty.</p></div>';
      if (foot) foot.innerHTML = ""; return;
    }
    var html = "";
    cart.items.forEach(function (item) {
      html += '<div class="mini-cart__item" data-key="' + item.key + '">' +
        '<img src="' + (item.image ? item.image.replace(/(\.[^.]*)$/, "_120x$1") : "") + '" alt="" loading="lazy">' +
        '<div class="meta"><h4>' + item.product_title + "</h4>" +
        (item.variant_title ? '<p class="price">' + item.variant_title + "</p>" : "") +
        '<div class="qty" style="margin-top:6px">' +
          '<button type="button" data-cart-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
          '<input value="' + item.quantity + '" readonly data-cart-input aria-label="Quantity" inputmode="numeric">' +
          '<button type="button" data-cart-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button class="mini-cart__remove" data-cart-change="' + item.key + '" data-qty="0" aria-label="Remove item" style="margin-top:8px;font-size:12px;background:none;border:none;padding:0;cursor:pointer;text-decoration:underline">Remove</button>' +
        "</div>" +
        '<div class="price">' + (rfPct ? '<span class="now">' + money(rfMember(item.final_line_price)) + '</span><s class="was" style="display:block;opacity:.55;font-weight:400;font-size:.85em">' + money(item.final_line_price) + '</s>' : money(item.final_line_price)) + "</div></div>";
    });
    body.innerHTML = html + '<div class="cart-xsell" data-xsell hidden></div>';
    loadXsell(cart);
    applyStockLimits(cart);
    if (foot) {
      var memberDisc = rfPct ? '<div style="margin-bottom:8px;color:var(--accent);font-size:13px">\u2713 Member price applied (' + rfPct + '% off)</div>' : ((cart.total_discount && cart.total_discount > 0) ? '<div class="flex items-center" style="justify-content:space-between;margin-bottom:8px;color:var(--accent)"><span>Discount</span><strong>-' + money(cart.total_discount) + "</strong></div>" : "");
      var rfFull = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price); var subTotal = rfMember(rfFull); if (!window.ReFoundMember) { memberDisc = ""; subTotal = rfFull; }
      foot.innerHTML = shipBar(cart) + memberDisc + '<div class="flex items-center" style="justify-content:space-between;margin-bottom:12px"><span>Subtotal</span><strong>' + money(subTotal) + "</strong></div>" +
        '<a href="/checkout" class="btn btn--filled btn--block btn--lg">Checkout</a>' +
        '<a href="/cart" class="btn btn--ghost btn--block" style="margin-top:8px">View basket</a>';
    }
  }
  function fetchCart() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function cartToast(msg) {
    if (!msg) return;
    var box = document.getElementById("cart-notice");
    if (box) {
      box.textContent = msg; box.hidden = false;
      clearTimeout(box._t); box._t = setTimeout(function () { box.hidden = true; }, 4500);
      return;
    }
    var prev = document.querySelector(".cart-toast"); if (prev) prev.remove();
    var t = document.createElement("div");
    t.className = "cart-toast"; t.setAttribute("role", "status"); t.textContent = msg;
    t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#111;color:#fff;padding:10px 16px;border-radius:10px;font-size:13px;line-height:1.3;z-index:100001;max-width:90vw;text-align:center;box-shadow:0 6px 24px rgba(0,0,0,.25)";
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  }
  var _cartStockMap = null;
  function _stepMax(e) { if (!e || !e.tracked || e.policy === "continue") return Infinity; return e.max; }
  function decorateStock() {
    var rows = document.querySelectorAll("#cart-drawer-body .mini-cart__item");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i], box = row.querySelector(".qty"); if (!box) continue;
      var btns = box.querySelectorAll("button"), dec = btns[0], inc = btns[btns.length - 1];
      var inp = box.querySelector("input[data-cart-input]");
      box.classList.remove("qty--locked");
      if (dec) { dec.disabled = false; dec.removeAttribute("aria-disabled"); }
      if (inc) { inc.disabled = false; inc.removeAttribute("aria-disabled"); }
      if (inp) { inp.readOnly = true; inp.removeAttribute("data-max"); inp.removeAttribute("title"); }
      if (!_cartStockMap) continue;
      var e = _cartStockMap[row.getAttribute("data-key")]; if (!e) continue;
      var max = _stepMax(e);
      if (max <= 1) {
        box.classList.add("qty--locked");
        if (dec) { dec.disabled = true; dec.setAttribute("aria-disabled", "true"); }
        if (inc) { inc.disabled = true; inc.setAttribute("aria-disabled", "true"); }
      } else {
        if (inp) { inp.readOnly = false; if (max !== Infinity) { inp.setAttribute("data-max", max); inp.setAttribute("title", "Up to " + max + " available"); } }
        if (e.qty >= max && inc) { inc.disabled = true; inc.setAttribute("aria-disabled", "true"); }
      }
    }
  }
  var _cartStockSig = null;
  function applyStockLimits(cart) {
    decorateStock();
    var sig = (cart && cart.items) ? cart.items.map(function (i) { return i.key; }).sort().join("|") : null;
    if (sig !== null && sig === _cartStockSig && _cartStockMap) { decorateStock(); return; }
    fetch("/?sections=cart-stock&cb=" + Date.now(), { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (secs) {
      var html = secs && secs["cart-stock"]; if (!html) return;
      var tmp = document.createElement("div"); tmp.innerHTML = html;
      var node = tmp.querySelector("[data-cart-stock]"); if (!node) return;
      var arr = JSON.parse(node.textContent.trim());
      _cartStockMap = {}; for (var j = 0; j < arr.length; j++) { _cartStockMap[arr[j].key] = arr[j]; }
      _cartStockSig = sig;
      decorateStock();
    }).catch(function () {});
  }
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute("aria-disabled", "true"); btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; }
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && (data.status >= 400 || (data.description && !data.id))) { cartToast(data.description || data.message || "Sorry, there is no more of this item available."); }
        fetchCart(); openDrawer("cart-drawer");
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.removeAttribute("aria-disabled"); btn.textContent = btn.dataset.label || "Add to basket"; } });
  });
  document.addEventListener("click", function (e) {
    var chg = e.target.closest("[data-cart-change]");
    if (!chg) return;
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: chg.getAttribute("data-cart-change"), quantity: parseInt(chg.getAttribute("data-qty"), 10) })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.items) { renderCart(data); return; }
      if (data && (data.description || data.message)) { cartToast(data.description || data.message); }
      fetchCart();
    }).catch(function () { fetchCart(); });
  });
  document.addEventListener("change", function (e) {
    var inp = e.target.closest("#cart-drawer-body input[data-cart-input]");
    if (!inp || inp.readOnly) return;
    var row = inp.closest(".mini-cart__item"); if (!row) return;
    var maxAttr = inp.getAttribute("data-max");
    var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    var val = parseInt(inp.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    var capped = val > max; if (capped) val = max;
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: row.getAttribute("data-key"), quantity: val })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.items) { renderCart(data); } else { if (data && (data.description || data.message)) { cartToast(data.description || data.message); } fetchCart(); }
      if (capped) { cartToast("Only " + max + " available — quantity set to the maximum."); }
    }).catch(function () { fetchCart(); });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var inp = e.target.closest("#cart-drawer-body input[data-cart-input]");
    if (inp && !inp.readOnly) { e.preventDefault(); inp.blur(); }
  });
  function rfStripGuestDiscount() {
    if (window.ReFoundMember) return;
    fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart) return;
      var has = cart.discount_codes && cart.discount_codes.some(function (d) { return d && d.code && d.code.toUpperCase() === "REFOUNDMEMBER"; });
      if (!has) return;
      fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" } }).then(function () { return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ discount: "" }) }); }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); }).catch(function () {});
    }).catch(function () {});
  }
  rfStripGuestDiscount();
  if (document.getElementById("cart-drawer")) fetchCart();

  /* ── Spotlight cursor glow (home) ──────────────────────────────────────── */
  var spotlight = document.querySelector(".spotlight");
  if (spotlight && window.matchMedia("(pointer:fine)").matches) {
    window.addEventListener("mousemove", function (e) {
      spotlight.style.opacity = "1"; spotlight.style.left = e.clientX + "px"; spotlight.style.top = e.clientY + "px";
    });
  }

  /* ── Accordions ────────────────────────────────────────────────────────── */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".accordion__btn");
    if (btn) btn.parentElement.classList.toggle("is-open");
  });

  /* ── Quantity steppers ─────────────────────────────────────────────────── */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-step]");
    if (!step) return;
    var qtyInput = step.parentElement.querySelector('input[name="quantity"]');
    if (qtyInput) { var v = parseInt(qtyInput.value || "1", 10) + parseInt(step.getAttribute("data-qty-step"), 10); var mx = parseInt(qtyInput.getAttribute("max"), 10); if (!isNaN(mx) && v > mx) { v = mx; } qtyInput.value = Math.max(1, v); }
  });

  /* ── PDP gallery thumbs ────────────────────────────────────────────────── */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    var main = document.querySelector("[data-gallery-main]");
    if (main) main.src = thumb.getAttribute("data-full") || thumb.querySelector("img").src;
    thumb.closest(".pdp__thumbs").querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
    thumb.classList.add("is-active");
  });

  /* ── Account dropdown (avatar menu) ────────────────────────────────────── */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-account-toggle]");
    var menu = document.querySelector("[data-account-menu]");
    if (toggle && menu) {
      e.preventDefault();
      var open = !menu.classList.contains("is-open");
      menu.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      return;
    }
    if (menu && menu.classList.contains("is-open") && !e.target.closest("[data-account-dropdown]")) {
      menu.classList.remove("is-open");
      var t = menu.querySelector("[data-account-toggle]");
      if (t) t.setAttribute("aria-expanded", "false");
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var m = document.querySelector("[data-account-menu].is-open");
    if (m) { m.classList.remove("is-open"); var t = m.querySelector("[data-account-toggle]"); if (t) t.setAttribute("aria-expanded", "false"); }
  });

  /* ── Wishlist (localStorage) ───────────────────────────────────────────── */
  var WL_KEY = "refound-wishlist";
  var wlApi = window.ReFoundWishlistApi, wlCid = window.ReFoundCustomerId, wlTimer;
  function wlPush() {
    if (!wlApi || !wlCid) return;
    clearTimeout(wlTimer);
    wlTimer = setTimeout(function () {
      fetch(wlApi, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "set", customerId: String(wlCid), handles: readWL() }) }).catch(function () {});
    }, 600);
  }
  function wlPull() {
    if (!wlApi || !wlCid) return;
    fetch(wlApi, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "get", customerId: String(wlCid) }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var server = (d && d.handles) || [], local = readWL(), merged = local.slice();
        server.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
        if (merged.length !== local.length) { writeWL(merged); refreshWishlistCount(); markWishlistHearts(); }
        if (merged.length !== server.length) wlPush();
      })
      .catch(function () {});
  }
  function readWL() { try { return JSON.parse(localStorage.getItem(WL_KEY) || "[]"); } catch (e) { return []; } }
  function writeWL(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} }
  function refreshWishlistCount() {
    var n = readWL().length;
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? "" : "none"; });
  }
  function markWishlistHearts() {
    var list = readWL();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute("data-wishlist-toggle")) !== -1;
      btn.classList.toggle("is-active", on);
      btn.style.color = on ? "var(--accent)" : "";
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute("data-wishlist-toggle"), list = readWL(), i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    writeWL(list); refreshWishlistCount(); markWishlistHearts(); wlPush();
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest('[data-drawer-open="wishlist-drawer"]')) return;
    var body = document.getElementById("wishlist-drawer-body");
    if (!body) return;
    var list = readWL();
    if (list.length === 0) { body.innerHTML = '<div class="mini-cart__empty"><p>Your wishlist is empty. Tap the heart on any item to save it.</p></div>'; return; }
    body.innerHTML = '<div class="wishlist-grid"></div>';
    var track = body.firstChild;
    list.forEach(function (h) {
      fetch("/products/" + h + "?view=card", { headers: { "Accept": "text/html" } })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) { if (html) track.insertAdjacentHTML("beforeend", html); markWishlistHearts(); })
        .catch(function () {});
    });
  });
  refreshWishlistCount();
  markWishlistHearts();
  wlPull();

  /* ── Recently viewed (localStorage) ────────────────────────────────────── */
  var RV_KEY = "refound-recently-viewed";
  function readRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || "[]"); } catch (e) { return []; } }
  var pdp = document.querySelector("[data-product-handle]");
  if (pdp && document.querySelector(".pdp")) {
    var handle = pdp.getAttribute("data-product-handle");
    if (handle) {
      var list = readRV().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }
  }
  var rvSection = document.getElementById("recently-viewed");
  if (rvSection) {
    var handles = readRV().filter(function (h) { return h !== rvSection.dataset.current; }).slice(0, 8);
    if (handles.length === 0) { rvSection.style.display = "none"; }
    else {
      var track = rvSection.querySelector("[data-rv-track]"), pending = handles.length, added = 0;
      handles.forEach(function (h) {
        fetch("/products/" + h + "?view=card", { headers: { "Accept": "text/html" } })
          .then(function (r) { return r.ok ? r.text() : ""; })
          .then(function (html) { if (html && track) { track.insertAdjacentHTML("beforeend", html); added++; } })
          .catch(function () {})
          .finally(function () { pending--; if (pending <= 0 && added === 0) rvSection.style.display = "none"; markWishlistHearts(); });
      });
    }
  }
})();

/* ── Predictive search (type-ahead) ─────────────────────────────────────── */
(function () {
  function bindScope(scope) {
  var box = scope.querySelector("[data-predictive]");
  var form = scope.querySelector(".search-form");
  var input = form && form.querySelector('input[type="search"]');
  if (!box || !form || !input) return;
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || "en-GB", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP" }).format(c / 100); }
    catch (e) { return "£" + (c / 100).toFixed(2); }
  }
  var t, lastQ = "", _ac = null;
  function close() { box.hidden = true; input.setAttribute("aria-expanded", "false"); }
  function render(d, q) {
    var res = (d.resources && d.resources.results) || {};
    var prods = res.products || [], colls = res.collections || [], pages = res.pages || [];
    if (!prods.length && !colls.length && !pages.length) { box.innerHTML = '<div class="predictive__empty">No matches for &ldquo;' + q.replace(/[<>]/g, "") + '&rdquo;</div>'; box.hidden = false; return; }
    var html = "";
    if (colls.length) html += '<div class="predictive__section">Categories</div>' + colls.slice(0, 3).map(function (c) { return '<a class="predictive__item" role="option" href="' + c.url + '"><span class="t">' + c.title + '</span></a>'; }).join("");
    if (prods.length) html += '<div class="predictive__section">Products</div>' + prods.slice(0, 6).map(function (p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || "");
      var pr = (p.price != null) ? p.price : p.price_min;
      var price = (typeof pr === "number") ? money(pr) : (pr || "");
      return '<a class="predictive__item" role="option" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + '<span><span class="t">' + p.title + '</span><br><span class="p">' + price + '</span></span></a>';
    }).join("");
    if (pages.length) html += '<div class="predictive__section">Pages</div>' + pages.slice(0, 3).map(function (pg) { return '<a class="predictive__item" role="option" href="' + pg.url + '"><span class="t">' + pg.title + '</span></a>'; }).join("");
    html += '<a class="predictive__all" href="/search?q=' + encodeURIComponent(q) + '">See all results &rarr;</a>';
    box.innerHTML = html; box.hidden = false; input.setAttribute("aria-expanded", "true");
  }
  function run() {
    var q = input.value.trim();
    if (q.length < 2) { close(); return; }
    if (q === lastQ && !box.hidden) return; lastQ = q;
    if (_ac) { _ac.abort(); } _ac = window.AbortController ? new AbortController() : null;
    fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,collection,page&resources[limit]=6", { headers: { "Accept": "application/json" }, signal: _ac ? _ac.signal : undefined })
      .then(function (r) { return r.json(); }).then(function (d) { render(d, q); }).catch(function () {});
  }
  input.setAttribute("role", "combobox"); input.setAttribute("aria-autocomplete", "list"); input.setAttribute("aria-expanded", "false"); box.setAttribute("role", "listbox");
  input.addEventListener("input", function () { clearTimeout(t); t = setTimeout(run, 180); });
  input.addEventListener("focus", function () { if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false; });
  document.addEventListener("click", function (e) { if (!scope.contains(e.target)) close(); });
  input.addEventListener("keydown", function (e) {
    if (e.key === "Escape") return close();
    var items = Array.prototype.slice.call(box.querySelectorAll(".predictive__item, .predictive__all"));
    if (!items.length) return;
    var idx = items.indexOf(document.activeElement);
    if (e.key === "ArrowDown") { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
    else if (e.key === "ArrowUp") { e.preventDefault(); (items[idx - 1] || input).focus(); }
  });
  }
  Array.prototype.forEach.call(document.querySelectorAll("[data-search-scope]"), bindScope);
})();

/* ── PDP image zoom / lightbox ──────────────────────────────────────────── */
(function () {
  var main = document.querySelector("[data-gallery-main]");
  if (!main) return;
  var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-gallery-thumb]"));
  var srcs = thumbs.length ? thumbs.map(function (th) { return th.getAttribute("data-full") || (th.querySelector("img") && th.querySelector("img").src); }) : [main.src];
  var cur = 0;
  var lb = document.createElement("div");
  lb.className = "lightbox"; lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true"); lb.setAttribute("aria-label", "Image viewer");
  lb.innerHTML = '<button class="lightbox__btn lightbox__btn--close" aria-label="Close">✕</button><button class="lightbox__btn lightbox__btn--prev" aria-label="Previous image">‹</button><img alt=""><button class="lightbox__btn lightbox__btn--next" aria-label="Next image">›</button>';
  document.body.appendChild(lb);
  var lbImg = lb.querySelector("img");
  function show(i) { cur = (i + srcs.length) % srcs.length; lbImg.src = srcs[cur]; }
  function open() { var idx = srcs.indexOf(main.src); show(idx >= 0 ? idx : 0); lb.classList.add("is-open"); document.body.style.overflow = "hidden"; }
  function close() { lb.classList.remove("is-open"); document.body.style.overflow = ""; }
  main.addEventListener("click", open);
  lb.addEventListener("click", function (e) {
    if (e.target.closest(".lightbox__btn--close") || e.target === lb) return close();
    if (e.target.closest(".lightbox__btn--next")) return show(cur + 1);
    if (e.target.closest(".lightbox__btn--prev")) return show(cur - 1);
  });
  document.addEventListener("keydown", function (e) {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") close(); else if (e.key === "ArrowRight") show(cur + 1); else if (e.key === "ArrowLeft") show(cur - 1);
  });
  thumbs.forEach(function (th, i) { th.addEventListener("click", function () { cur = i; }); });
})();

/* ── Sticky mobile add-to-basket bar (PDP) ──────────────────────────────── */
(function () {
  var form = document.getElementById("product-form");
  var addBtn = form && form.querySelector("[data-add-btn]");
  if (!form || !addBtn) return;
  var titleEl = document.querySelector(".pdp__title");
  var priceEl = document.querySelector(".pdp__price [data-price]");
  var bar = document.createElement("div");
  bar.className = "pdp-sticky";
  bar.innerHTML = '<div class="pdp-sticky__info"><div class="pdp-sticky__title"></div><div class="pdp-sticky__price"></div></div><button class="btn btn--filled" type="button">Add to basket</button>';
  document.body.appendChild(bar);
  document.body.classList.add("pdp-has-sticky");
  bar.querySelector(".pdp-sticky__title").textContent = titleEl ? titleEl.textContent.trim() : "";
  var sBtn = bar.querySelector("button");
  function sync() {
    bar.querySelector(".pdp-sticky__price").textContent = priceEl ? priceEl.textContent.trim() : "";
    sBtn.disabled = addBtn.disabled;
    sBtn.textContent = addBtn.disabled ? "Sold out" : "Add to basket";
  }
  sync();
  sBtn.addEventListener("click", function () { if (addBtn.disabled) return; if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) { entries.forEach(function (en) { bar.classList.toggle("is-visible", !en.isIntersecting); }); }, { rootMargin: "0px 0px -10% 0px" }).observe(addBtn);
  }
  document.addEventListener("variant:changed", sync);
})();
